import { motion } from 'framer-motion';
import { Zap, FileText, RotateCcw, Package, TrendingUp, Users, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Container } from '../ui/Container';

const AGENT_ICONS = [FileText, RotateCcw, Package, TrendingUp, Users];

export function AdhaClawSection() {
  const { t } = useTranslation();
  const tasks = t('adhaClaw.tasks', { returnObjects: true }) as string[];

  return (
    <section className="w-full py-16 sm:py-20 bg-gray-50 border-b border-gray-100">
      <Container>
        <div className="max-w-2xl mx-auto text-center mb-10">
          <div className="inline-flex items-center gap-2 rounded-full border border-orange-200 bg-orange-50 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-orange-600 mb-4">
            <Zap className="h-3.5 w-3.5" />
            {t('adhaClaw.badge')}
          </div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            {t('adhaClaw.title')}{' '}
            <span className="text-orange-500">{t('adhaClaw.titleHighlight')}</span>
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            {t('adhaClaw.description')}
          </p>
        </div>

        <p className="text-center text-xs font-semibold uppercase tracking-wider text-gray-400 mb-4">
          {t('adhaClaw.tasksLabel')}
        </p>
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {tasks.map((task, i) => {
            const Icon = AGENT_ICONS[i] ?? FileText;
            return (
              <motion.div
                key={task}
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.25, delay: i * 0.06 }}
                viewport={{ once: true }}
                className="inline-flex items-center gap-2.5 rounded-xl border border-gray-200 bg-white px-4 py-3 text-sm font-medium text-gray-700 hover:border-orange-200 hover:text-orange-600 transition-colors"
              >
                <Icon className="h-4 w-4 text-orange-500 shrink-0" />
                {task}
              </motion.div>
            );
          })}
        </div>

        <div className="flex justify-center">
          <Link
            to="/applications/adha-claw"
            className="inline-flex items-center gap-2 rounded-xl bg-orange-500 px-6 py-3 text-sm font-semibold text-white hover:bg-orange-600 transition-colors"
          >
            {t('adhaClaw.cta')}
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </Container>
    </section>
  );
}
